"use client";

import React, { useState, useEffect } from "react";
import style from "@/components/Products/cateogry.module.scss";
import { PriceIntervals } from "@/common/entities/product/Attributes";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import styled from "styled-components";


const RangeFilter = styled(RangeSlider)`
    .range-slider__range {
        background: var(--primary-color) !important;
    }

    .range-slider__track {
        background: #dee2e6 !important;
    }

    .range-slider__thumb {
        background: var(--primary-color);
        border: 2px solid white;
    }
`;

interface SingleAttributeSideFilterProps {
    onPriceIntervalFilter: (min: number, max: number) => void;
    filters: { [key: string]: string | undefined };
    priceIntervals?: PriceIntervals;
}

const PriceIntervalsFilter = ({ onPriceIntervalFilter, filters, priceIntervals }: SingleAttributeSideFilterProps) => {
    const sliderMin = priceIntervals?.min ?? 0;
    const sliderMax = priceIntervals?.max ?? 1000;

    const initialMin = !isNaN(parseInt(filters.minPrice || "", 10)) ? parseInt(filters.minPrice || "", 10) : sliderMin;
    const initialMax = !isNaN(parseInt(filters.maxPrice || "", 10)) ? parseInt(filters.maxPrice || "", 10) : sliderMax;

    const [range, setRange] = useState<[number, number]>([initialMin, initialMax]);

    useEffect(() => {
        setRange([initialMin, initialMax]);
    }, [initialMin, initialMax]);

    const handleValueChange = (values: number | number[] | undefined) => {
        if (Array.isArray(values)) {
            setRange([values[0], values[1]]);
            onPriceIntervalFilter(values[0], values[1]);
        }
    };

    if (!priceIntervals) return null;

    return (
        <div className={style.cardFilter}>
            <h5 className={style.cardTitle}>Pret</h5>

            <div className="d-flex justify-content-between mb-2">
                <small className="text-secondary">{range[0] ?? sliderMin} RON</small>
                <small className="text-secondary">{range[1] ?? sliderMax} RON</small>
            </div>

            <RangeFilter
                min={sliderMin}
                max={sliderMax}
                step={50}
                value={range}
                onInput={handleValueChange}
                ariaLabel={["Pret minim", "Pret maxim"]}
                thumbsDisabled={[false, false]}
                rangeSlideDisabled={false}
                className="mb-4"
            />
        </div>
    );
};

export default PriceIntervalsFilter;
